"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userIsEmployerUser = void 0;
const user_shared_1 = require("@engineering11/user-shared");
const userIsEmployerUser = (user) => user.userType === user_shared_1.UserType.Business;
exports.userIsEmployerUser = userIsEmployerUser;
